import React from 'react';
import styled from 'styled-components';
import { Paragraph } from '@99designs/emu';
import { mediaQuery } from '@99designs/emu/css';
import { spaces, typography } from '@99designs/emu/settings';

export interface CalloutStatsProps {
    side: React.ReactNode;
    stats: string;
    body: string;
}

export default function CalloutStats(props: CalloutStatsProps) {
    return (
        <CalloutContainer>
            <ChartContainer>{props.side}</ChartContainer>
            <StatsContainer>
                <Stat>{props.stats}</Stat>
                <Paragraph fontFamily="cite" italic={true} size="large" lineHeight="h0">
                    {props.body}
                </Paragraph>
            </StatsContainer>
        </CalloutContainer>
    );
}

const CalloutContainer = styled.div`
    display: flex;
    column-gap: ${spaces['2bu']};
`;

const ChartContainer = styled.div`
    text-align: center;
    padding-top: ${spaces['1.5bu']};
`;

const Stat = styled.div`
    line-height: ${typography.lineHeights.h0};
    font-family: ${typography.fontFamilies.cite};
    font-style: italic;
    font-size: 100px;
    margin-bottom: ${spaces['0.75bu']};

    ${mediaQuery.between('small', 'medium')} {
        font-size: 80px;
    }
`;

const StatsContainer = styled.div`
    display: flex;
    flex-direction: column;
`;
